import { defineMessages } from 'react-intl';

export const dcInstanceDetailsMessages = defineMessages({
	organizationsBreadcrumb: {
		id: 'fastshift.dc-instance-details.organizations-breadcrumb',
		defaultMessage: 'Organizations',
		description: 'Breadcrumb label linking to the FastShift organizations list.',
	},
	organizationBreadcrumb: {
		id: 'fastshift.dc-instance-details.organization-breadcrumb',
		defaultMessage: 'Organization details',
		description: 'Breadcrumb label linking to the parent organization details page.',
	},
	pageTitleFallback: {
		id: 'fastshift.dc-instance-details.page-title-fallback',
		defaultMessage: 'Data Center instance',
		description: 'Fallback title for a Data Center instance when its base URL is not available.',
	},
	loadingLabel: {
		id: 'fastshift.dc-instance-details.loading-label',
		defaultMessage: 'Loading Data Center instance details',
		description: 'Accessible label for the DC instance details page loading indicator.',
	},
});
